
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hotelSlug]/bookings/amend/[previousId]/[newHotelSlug]/[newId]/confirmation",
      function () {
        return require("private-next-pages/[hotelSlug]/bookings/amend/[previousId]/[newHotelSlug]/[newId]/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hotelSlug]/bookings/amend/[previousId]/[newHotelSlug]/[newId]/confirmation"])
      });
    }
  